<template>
  <div>
    <footer class="footer" style="height: 36px; padding: 0 30px 0 12px;" v-if="lumbredocs_v3">
      <div class="d-flex justify-content-between align-items-center h-100">
        <a :href="creatorUrl" target="_blank">
          <img :src="$store.state.settings.logoLumbreDocs" style="height: 40px; margin-top:-3px" height="40px" alt="Logo" class="py-2">
        </a>
        <p class="mb-0 pr-0 d-none d-md-block">
          {{ (new Date()).getFullYear() }} © <a :href="creatorUrl" target="_blank">Lumile</a> {{lumbreVersion}}
        </p>
      </div>
    </footer>
    <footer class="footer" v-else>
      <div class="container-fluid">
        <div class="row">
          <p class="col-12 mb-0">
            {{ (new Date()).getFullYear() }} © <a :href="creatorUrl" target="_blank">Lumile</a> {{lumbreVersion}}
          </p>
        </div>
      </div>
    </footer>
    <nav class="nav">
      <ul class="shadow" v-if="menuItems.length > 0">
        <li v-for="(item, index) in filteredMenuItems" :key="'menuItems'+index">
          <router-link :to="item.path ? item.path : '/'">
            <span class="icon"><i :class="item.icon" /></span>
            <div class="name">{{ item.name }}</div>
         </router-link>
        </li>
        <li v-if="menuItems.length > 1" @click="toggleMenu">
          <span class="icon"><i class="mdi mdi-menu"></i></span>
        </li>
      </ul>
    </nav>
    <div class="menu" :class="{ collapsed: collapsed }">
      <ul>
        <li v-for="(item, index) in filteredMenuItems" :key="'mItems'+index" @click="toggleMenu">
          <router-link :to="item.path ? item.path : '/'" class="w-full py-3 pl-3">
            <span class="icon"><i :class="item.icon" /></span>
            <div class="name">{{ item.name }}</div>
          </router-link>
        </li>
        <li v-if="settingsItem" @click="toggleSetting">
          <a href="javascript:void(0)" class="w-full py-3 pl-3">
            <span class="icon"><i :class="settingsItem.icon" /></span>
            <div class="name">{{ settingsItem.name }}</div>
          </a>

          <div class="scrollable" :class="{ collapsedSetting: collapsedSetting }">
            <router-link
              v-for="item of settingsItem.childs"
              :key="item.index"
              class="menu-item"
              :to="item.path"
            >
              <div class="menu-item-content  w-full py-2.5" @click="toggleMenu">
                <span class="icon pl-4"><i :class="item.icon" /></span>
                <span class="text">{{ item.name }}</span>
              </div>
            </router-link>
          </div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import { version } from '../../package.json'
import { mapState, mapGetters } from 'vuex'

export default {
  inject: ['lumbredocs_v3'],
  computed: {
    ...mapState('session', ['bVersion']),
    ...mapGetters('settings', [
      'menuItems',
      'settingsItem'
    ]),
    filteredMenuItems () {
      return this.menuItems.slice(0, 4)
    },
    lumbreVersion () {
      let version
      if (this.bVersion) {
        version = `(${this.appVersion} - Engine: ${this.bVersion})`
      } else {
        version = `(v${this.appVersion})`
      }
      return version
    }
  },
  data () {
    return {
      appVersion: version,
      creatorUrl: process.env?.VUE_APP_LUMBREDOCS_CREATOR_URL || 'https://www.lumile.com.ar',
      collapsed: true,
      collapsedSetting: true
    }
  },
  methods: {
    toggleMenu () {
      this.collapsed = !this.collapsed
    },
    toggleSetting () {
      this.collapsedSetting = !this.collapsedSetting
    }
  }
}
</script>

<style scoped>
  .footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  border-top: 1px solid rgba(152,166,173,.3);
  padding: 19px 30px 20px;
  color: var(--mutedFontThemeColor);
  background: #fafbfe;
  z-index: 1000;
}

@media (max-width: 992px) {
  .footer {
    display: none;
  }
  .menu ul li:nth-child(1), .menu ul li:nth-child(2), .menu ul li:nth-child(3), .menu ul li:nth-child(4) {
    display: none;
  }
}

.nav {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 5000;
}

.nav ul {
  display: flex;
  background: #fff;
  width: 100%;
}

@media (min-width: 992px) {
  .nav ul {
    display: none;
  }
}

.nav ul li {
  display: flex;
  padding: 0.6em 0.8em 1em 0.8em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  flex-basis: 0;
  border-top: 1px solid rgba(152, 166, 173, 0.3);
  border-left: 1px solid rgba(152, 166, 173, 0.3);
  text-align: center;
  font-size: 14px !important;
  color: #444;
  flex: 1;
}

.nav ul li .name {
  color: #999;
  font-size: 11px;
  line-height: 1.2em;
  width: 84px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
}

.nav ul li .icon {
  font-size: 1.2em;
}

@media (max-width: 768px) {
  .nav ul li:nth-child(4) {
    display: none;
  }
  .menu ul li:nth-child(1), .menu ul li:nth-child(2), .menu ul li:nth-child(3){
    display: none;
  }
  .menu ul li:nth-child(3){
    display: block;
  }
}

@media (max-width: 374px) {
  .nav ul li:nth-child(3) {
    display: none;
  }
  .menu ul li:nth-child(1), .menu ul li:nth-child(2), .menu ul li:nth-child(3){
    display: none;
  }
  .menu ul li:nth-child(2), .menu ul li:nth-child(3){
    display: block;
  }
}

.menu {
  position: fixed;
  top: 65px;
  width: 100%;
  height: calc(100% - 63px - 65px);
  background: #fff;
  z-index: 5000;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
  transition: all 0.3s ease;
  overflow: auto;
}

@media (min-width: 992px) {
  .menu {
    display: none;
  }
}

.menu ul {
  width: 100%;
}

.menu ul li a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid rgba(152, 166, 173, 0.3);
}

.menu ul li a .icon {
  margin-right: 1em;
  margin-top: -5px;
}

.menu.collapsed {
  opacity: 0;
  visibility: hidden;
  transform: translateX(-50px);
  z-index: -1;
}

.scrollable {
  display: initial;
}

.scrollable.collapsedSetting {
  display: none;
}

</style>
